<template>
    <div class="box">
        <!-- 待选 -->
        <el-card class="box-card card-left">
            <div slot="header" class="clearfix">
              <span>{{sourceList.toSelectedList.title}}</span>
              <el-button style="float: right; padding: 3px 0" type="text" :disabled="sourceList.toSelectedList.disabledSearch" @click="handleSelectAll">全选</el-button>
            </div>
            <el-input class="filter-item" size="mini" v-model="sourceList.toSelectedList.search" @input="changeToSearch" clearable placeholder="输入关键字搜索"></el-input>
            
            <!-- 树形控件 -->
            <div class="list" v-loading="sourceList.toSelectedList.treeload">
              <el-scrollbar wrap-class="scrollbar-wrapper">
                <!-- 不关联-->
                <el-tree ref="toTree" node-key="id"
                  :data="sourceList.toSelectedList.list" :props="defaultProps" check-strictly show-checkbox @check-change="handleCheckChange" @check="handleCheck"
                  :filter-node-method="filterNode">
                  <span style="font-size:14px;" slot-scope="{data}" :title="data.title">{{data.title}}</span>
                </el-tree>
              </el-scrollbar>
            </div>
        </el-card>

         <!-- 已选 -->
        <el-card class="box-card card-right">
            <div slot="header" class="clearfix">
              <span>{{sourceList.selectedList.title}}</span>
              <el-button style="float: right; padding: 3px 0;" type="text" :disabled="sourceList.selectedList.disabledSearch" @click="handleEmpty">清空</el-button>
            </div>
            <el-input class="filter-item" size="mini" v-model="sourceList.selectedList.search" @input="changeSearch" clearable placeholder="输入关键字搜索"></el-input>
            <div class="list">
              <el-scrollbar wrap-class="scrollbar-wrapper">
                <div class="item" v-for="item in sourceList.selectedList.list" :key="item.id">
                  <span >{{item.title}}</span>
                  <el-button  size="mini" type="danger" icon="el-icon-delete" circle @click="treetabledelete(item)"></el-button>
                </div>
              </el-scrollbar>
            </div>
        </el-card>
    </div>
</template>

<script>
export default {
    data() {
        return {

            defaultProps: {
                children: 'childs',
                label: 'title',
            },

            sourceList : {
                toSelectedList: { // 待选数据
                    title: '待选', // 待选标题
                    search: '',
                    disabledSearch: true,
                    treeload: true,
                    list: []
                },
                selectedList: { // 已选数据
                    title: '已选',
                    search: '',
                    disabledSearch: true,
                    treeload: false,
                    rawList: [], // 记录原始数据
                    list: []
                }
            }
        }
    },
    created() {
        this.sourceList.toSelectedList.list = this.transformList(this.sourceList.toSelectedList.list)
    },
    methods: {
        // 转换待选列表
        transformList(list) {
            let data = []
            if (list && list.length > 0) {
                data = list.map(f => {
                    this.$set(f,'disabled',false)
                    if (f.childs && f.childs.length > 0) {
                        this.transformList(f.childs)
                    }

                    if (!f.id) {
                        f.id = ''
                    }
                    return f
                })
            }

            return data
        },

        // 监听待选 input 搜索框
        changeToSearch(val) {
            // console.log(val)
            this.$refs['toTree'].filter(val);
            if (val) {
                this.sourceList.toSelectedList.disabledSearch = true
            } else {
                this.sourceList.toSelectedList.disabledSearch = false
            }
        },

        // 筛选
        filterNode(value, data) {
            if (!value) return true;
            if (data.title != null) {  
                return data.title.toLowerCase().replace(/\s+/g, "").indexOf(value) !== -1
            }
        },

        // 全选
        handleSelectAll() {
            let ids = []

            this.sourceList.toSelectedList.list.forEach(item => {
                ids.push(item.id)
            })
    
            this.$refs['toTree'].setCheckedKeys(ids) // 设置要选项

            const checkedNodes = JSON.parse(JSON.stringify(this.$refs['toTree'].getCheckedNodes())) // 获取已选节点
            this.exportCheckeds(checkedNodes) // 获取最终取值
        },

        // 点击选中框
        handleCheck(e) {
            const checkedNodes = JSON.parse(JSON.stringify(this.$refs['toTree'].getCheckedNodes())) // 获取已选节点
            this.exportCheckeds(checkedNodes)
        },

        // 选中状态变化
        handleCheckChange(e, checked) {
            if (checked) {
                this.checkedChilds(e, checked)
            } else {
                if (e.disabled) {
                    this.checkedChilds(e, true)
                } else {
                    this.checkedChilds(e, checked)
                }
            }
        },

        // 转换选中的子集为禁用状态
        checkedChilds(list, checked) {
            if (list.childs && list.childs.length > 0) {
                list.childs.forEach(c => {
                    if (checked) {
                        c.disabled = true
                    } else {
                        c.disabled = false
                    }
                    if (c.childs && c.childs.length > 0) {
                        this.checkedChilds(c, checked)
                    }
                })
            }
        },

        // 导出最终已选列表
        exportCheckeds(arr) {
            const checkeds = []
            const ids = []
            arr.forEach(a => {
                if (a.disabled == false) {
                    checkeds.push(a)
                    ids.push(Number(a.id))
                }
            })
            if (this.sourceList.selectedList.search) {
                this.sourceList.selectedList.rawList = checkeds
                this.changeSearch(this.sourceList.selectedList.search)
            } else {
                this.sourceList.selectedList.rawList = this.sourceList.selectedList.list = checkeds // 最终结果 
            }

            // 设置最终选中的样式
            this.$refs['toTree'].setCheckedKeys(ids) // 设置要选项

            // 设置已选清空按钮的点击状态
            if (this.sourceList.selectedList.list.length > 0 && !this.sourceList.selectedList.search) {
                this.sourceList.selectedList.disabledSearch = false
            } else {
                this.sourceList.selectedList.disabledSearch = true
            }
            this.$emit('changeRoles')
        },

        // 监听已选
        changeSearch(val) {
            const search = val.toLowerCase().replace(/\s+/g, "");
            if (search) {
                this.sourceList.selectedList.disabledSearch = true
                // console.log()
                const list = this.sourceList.selectedList.rawList.filter(data => {
                    return String(data['title']).toLowerCase().indexOf(search) > -1
                })
                return this.sourceList.selectedList.list = list
            } else {
                this.sourceList.selectedList.disabledSearch = false
            }

            return this.sourceList.selectedList.list = JSON.parse(JSON.stringify(this.sourceList.selectedList.rawList))
        },

        // 清空
        handleEmpty() {
            this.sourceList.selectedList.rawList = this.sourceList.selectedList.list = []
            this.$refs['toTree'].setCheckedKeys([]) // 设置要选项
            this.sourceList.selectedList.disabledSearch = true
            if (!this.sourceList.toSelectedList.search) {
                this.sourceList.toSelectedList.disabledSearch = false
            }

            const checkedNodes = JSON.parse(JSON.stringify(this.$refs['toTree'].getCheckedNodes())) // 获取已选节点
            this.exportCheckeds(checkedNodes)
        },

        // 删除
        treetabledelete(row) {
            //console.log(item, index, row)
            let ids = []
            this.sourceList.selectedList.rawList.forEach(son => {
                if (son.id !== row.id) {
                ids.push(son.id)
                }
            })

            this.$refs['toTree'].setCheckedKeys(ids) // 设置要选项

            const checkedNodes = JSON.parse(JSON.stringify(this.$refs['toTree'].getCheckedNodes())) // 获取已选节点
            this.exportCheckeds(checkedNodes) // 获取最终取值

            if (!this.sourceList.toSelectedList.search) {
                this.sourceList.toSelectedList.disabledSearch = false
            }
        },

    }
}
</script>

<style lang="scss" scoped>
.box {
  padding: 0 12px;
  max-width: 50vw;
  width: 80%;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  .box-card {
    width: 100%;
  }
  .card-left {
    margin-right: 10px;
  }
  .card-right {
    margin-left: 10px;
  }
  ::v-deep .el-card__header {
    padding: 3px 20px;
    line-height: 28px;
  }
  .filter-item {
    width: 100%;
    margin-bottom: 10px;
  }

  ::v-deep :focus {
    outline: 0;
  }

  .list {
    height: 400px;
    .item {
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #f1f1f1;
      padding: 5px 10px 5px 0;
    }
  }

  ::v-deep .scrollbar-wrapper {
    overflow-x: hidden !important;
  }

  .el-scrollbar__bar.is-vertical {
    right: 0px;
  }

  .el-scrollbar {
    height: 100%;
  }
}
</style>